import { useState, useEffect } from 'react';
import { Card, Row, Col, Typography, Tooltip } from 'antd';
import AnnouncementConfig from "@/config/announcement";
import {
  getStartTimeToday,
  getEndTimeAfterXDays,
  convertToTimestamp,
  convertTimestampToFormat,
  dateFormat,
} from "@lib/dateTime";
import { getLangList } from '@/lib/i18n';
import { filterScheduleArrayByTarget, getActionDepartmentArray } from '@/lib/schedule';
import { ScheduleType, DepartmentType } from "./types";
import ScheduleModal from './ScheduleModal';

const { getCalendarInfo } = AnnouncementConfig;

type Props = {
  departmentArray: DepartmentType[],
  roleId: number,
}

function RecentSchedule(props: Props) {
  const { departmentArray, roleId } = props;
  const [scheduleArray, setScheduleArray] = useState<ScheduleType[]>([]);
  const [selectedSchedule, setSelectedSchedule] = useState<ScheduleType>({} as ScheduleType);
  const filterScheduleArray = filterScheduleArrayByTarget(scheduleArray, roleId);
  const departmentIdArray = getActionDepartmentArray(departmentArray, 0).map((item: any) => item.id); // 可 view 的 id[]
  const viewScheduleArray = filterScheduleArray.filter((item: any) => departmentIdArray.indexOf(+item.departmentId) > -1);
  const homeT: any = getLangList("home");

  useEffect(() => {
    getCalendarInfoFunction();
  }, []);

  function getCalendarInfoFunction() {
    const params = {
      startTime: convertToTimestamp(getStartTimeToday()),
      endTime: convertToTimestamp(getEndTimeAfterXDays(1)),
    }

    getCalendarInfo(params).then((res: any) => {
      const { value = [] } = res ?? {};
      setScheduleArray(value);
    });
  }

  return (
    <>
      <Card
        title={homeT.RECENT_SCHEDULE}
        size="small"
        className="schedule-card"
      >
        <Row className="home-two-day-list-container" gutter={[12, 12]}>
          {viewScheduleArray.map((item: ScheduleType, index: number) => {
            const { startTime, departmentId, title } = item;
            const departmentName = departmentArray?.find((department: any) => department.id === +departmentId)?.departmentName ?? '';

            return title
              ? (
                <Col span={24} key={index} onClick={() => setSelectedSchedule({ ...item, departmentName })}>
                  <Row gutter={[24, 24]} wrap={false}>
                    <Col className="home-two-day-list-date" flex={"0 1 112px"}>
                      <Tooltip title="2022-12-12">
                        <Typography.Text ellipsis>{convertTimestampToFormat(startTime, dateFormat)}</Typography.Text>
                      </Tooltip>
                    </Col>

                    <Col className="home-two-day-list-emphasize" flex={"0 2 80px"}>
                      <Tooltip title={departmentName}>
                        <Typography.Text ellipsis>{departmentName}</Typography.Text>
                      </Tooltip>
                    </Col>

                    <Col className="home-two-day-list-title" flex={"1 2 66px"}>
                      <Tooltip title={title}>
                        <Typography.Text ellipsis>
                          {title}
                        </Typography.Text>
                      </Tooltip>
                    </Col>
                  </Row>
                </Col>
              )
              : null;
          })}
        </Row>
      </Card>

      {Object.keys(selectedSchedule).length > 0 &&
        <ScheduleModal
          scheduleItem={selectedSchedule}
          onCancel={() => setSelectedSchedule({} as ScheduleType)}
        />
      }
    </>
  );
}

export default RecentSchedule;